import LillyLogoSvg from "../../LdsLillyLogo/LillyLogoSvg.jsx";
export default function UtilityLogo() {
  return (
    <div className="utility-logo">
      <a href="https://www.lilly.com" target="_blank" rel="noreferrer">
        <LillyLogoSvg className="lds-header-utility-logo" />
      </a>
    </div>
  );
}
